const route = window.sessionStorage.getItem("route")

const initialState = {
    route: route,
};

export default initialState;
